'use client';

import { Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
// import { Button } from '@prismo-io/design-system';
import { Application, translate } from '@prismo-io/router';
import { LanguageCode, type LanguageCodeT } from '@prismo-io/schemas';
import { useRouter } from 'next/navigation';
import { type FC, useEffect, useState } from 'react';
import { useSignOut } from '../../hooks';

type Props = {
  modalIsOpen: boolean;
  onCloseDialog: () => void;
};

const buildSuccessUrl = (locale: LanguageCodeT) => {
  // eslint-disable-next-line no-constant-condition, prettier/prettier
  return translate({
    app: Application.APP,
    path: `/`,
    locale,
  });
};

export const SignOutModal: FC<Props> = (props: Props) => {
  const { modalIsOpen, onCloseDialog } = props;
  const { i18n } = useLingui();
  const { locale = LanguageCode.Enum.fr } = i18n;

  const successUrl = buildSuccessUrl(locale as LanguageCodeT);

  const [signOutDialog, setSignOutDialog] = useState<boolean>(modalIsOpen);
  const { trigger: signOut } = useSignOut();

  useEffect(() => {
    setSignOutDialog(modalIsOpen);
  }, [modalIsOpen]);

  const router = useRouter();

  const onConfirmSignOut = async () => {
    // setSignOutDialog(false);
    onCloseDialog;
    signOut(undefined, {
      onSuccess() {
        router.push(successUrl);
      },
    });
  };

  return (
    <Dialog open={signOutDialog} onClose={onCloseDialog} maxWidth="md">
      <DialogTitle>
        <Typography variant="h2" textAlign="center">
          <Trans>Déconnexion</Trans>
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography textAlign="center">
          <Trans>Souhaitez-vous vraiment vous déconnecter ?</Trans>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Button variant="text" color="gray" onClick={onCloseDialog}>
            <Trans>Non</Trans>
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={onConfirmSignOut}
            data-testid="logout-yes-btn"
          >
            <Trans>Oui</Trans>
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
